import { Card } from '@common/ui/Card';

import { type MatchmakerMode } from '@services/AnalyticsService';

import styles from './ModeSwitch.module.scss';

export type ModeSwitchProps = {
  mode: MatchmakerMode;
  hasIncomingSuperlikes: boolean;
  onChange: (mode: MatchmakerMode) => void;
};

const OPTIONS: { mode: MatchmakerMode; label: string }[] = [
  { mode: 'dating', label: 'Знакомлюсь' },
  { mode: 'matchmaker', label: 'Сваха' },
];

/** «Знакомлюсь / Сваха», in the sign-up gender picker's look. */
export const ModeSwitch = ({
  mode,
  hasIncomingSuperlikes,
  onChange,
}: ModeSwitchProps) => {
  return (
    <div
      role="tablist"
      aria-label="Режим"
      className={styles.modeSwitch}
      data-test-id="mode-switch"
    >
      {OPTIONS.map((option) => {
        const isSelected = option.mode === mode;

        return (
          <Card
            key={option.mode}
            testId={`mode-switch-${option.mode}-option`}
            role="tab"
            aria-selected={isSelected}
            variant="outlined"
            selected={isSelected}
            className={styles.option}
            onClick={() => {
              if (!isSelected) onChange(option.mode);
            }}
          >
            <span className={styles.label}>
              {option.label}
              {option.mode === 'dating' && hasIncomingSuperlikes && (
                <span
                  aria-hidden="true"
                  className={styles.dot}
                  data-test-id="mode-switch-superlike-dot"
                />
              )}
            </span>
          </Card>
        );
      })}
    </div>
  );
};
